/**
 * User role codes as returned by the backend. Kept in a dependency-free
 * module so it can be imported from anywhere without dragging Redux,
 * axios or i18n along with it (which is what causes circular imports
 * when consumed via `users.service.js`).
 *
 * `users.service.js` re-exports this object to preserve its public API.
 */

export const USER_ROLES = {
  student: 'R01',
  teacher: 'R02',
  teacherAdmin: 'R03',
  admin: 'R04',
  helpDesk: 'R05',
  adminFixedLayout: 'R06',
  publisher: 'R07',
} as const;

export type UserRoleKey = keyof typeof USER_ROLES;
export type UserRoleValue = (typeof USER_ROLES)[UserRoleKey];

/**
 * Role codes that belong to the front-office (student / teacher /
 * teacher admin). Used to filter user lists.
 */
export const FO: UserRoleValue[] = [USER_ROLES.student, USER_ROLES.teacher, USER_ROLES.teacherAdmin];

/**
 * Roles allowed to open a backoffice session. Sent as `admitted_roles` by the
 * password login and enforced on the link login, so both entry points agree.
 */
export const BACKOFFICE_ADMITTED_ROLES: UserRoleValue[] = [USER_ROLES.admin, USER_ROLES.helpDesk, USER_ROLES.adminFixedLayout, USER_ROLES.publisher];
